import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiUrl from '../../Apiurl';
import stilePulsanti from '../../interfaccia/stilePulsanti';
import ListaScegli from './ListaScegli';

function ListaAssocia({
  utente,
  idElemento1,
  colonnaID1,
  colonnaID2,
  tipoCong,
  tabellaElemento2,
  riquadroElemento2,
  height,
  titolo,
  token,
  querySpecifica
}) {
  
    const [arr,setArr] = useState([]);
    const [schermata,setSchermata] = useState(false);
    const [lista,setLista] = useState([]);
    const [loading,setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');
    const filteredItemsNome = lista.filter(
		item => item.nome && item.nome.toLowerCase().includes(filterText.toLowerCase()),
	  );

    ////////////////////       FETCH INIZIALE      ///////////////////////////
    const fetch = async () => {
        setLoading(true);
        if (!querySpecifica) {
            const nuoviParams = new URLSearchParams({
                tabella: tabellaElemento2,
                colonnaID1: colonnaID1,
                colonnaID2: colonnaID2,
                tipoCong: tipoCong,
                id: idElemento1
            })
            const response = await axios.get(apiUrl + "/anagrafiche/listaGenericaDaID?"+nuoviParams);
            setLoading(false);
            setArr(response.data);
        } else {
            const response = await axios.get(apiUrl + querySpecifica +"/"+idElemento1);
            setLoading(false);
            setArr(response.data);
        }        
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch();
    }, [token]);
    //////////////////////////////////////////////////////////////////////////

    const fetchLista = async () => {
            const nuoviParams = new URLSearchParams({
              tabella: tabellaElemento2,
              ordinamento: "ORDER BY id DESC"
          })
          const response = await axios.get(apiUrl + "/anagrafiche/generica?"+nuoviParams);
          setLista(response.data);            
    };

    const handleChange = async function (evt) {
      const value = evt.target.value;
      try {
          setFilterText(value);
      } catch (err) {
          console.log("Errore nell'aggiornamento di un dato non nestato: " + err)
          throw err;
      }
    }

    const associa = async function (id2) {
      if (utente.permessiAPI["update:database"]) {
        const nuoviParams = new URLSearchParams({
          [colonnaID1]: idElemento1,
          [colonnaID2]: id2,
          tipoCong: tipoCong
      })
      const config = {
        headers: {
            'Authorization': 'Bearer ' + token,
        }
    }
      const response = await axios.post(apiUrl + "/anagrafiche/associa?"+nuoviParams, null, config);
      if (response) {
        setSchermata(false);
        fetch();
      }
      } else {
        alert("Non hai i permessi necessari per farlo");
      }
      
        
    }

    const rimuoviAssociazione = async function (id2) {
      if (utente.permessiAPI["update:database"]) {
        /* console.log("id2",id2)
        console.log({[colonnaID1]: idElemento1,
          [colonnaID2]: id2,
          tipoCong: tipoCong}) */
        const nuoviParams = new URLSearchParams({
          [colonnaID1]: idElemento1,
          [colonnaID2]: id2,
          tipoCong: tipoCong
      })
      const config = {
        headers: {
            'Authorization': 'Bearer ' + token,
        }
    }
      const response = await axios.delete(apiUrl + "/anagrafiche/rimuoviAssociazione?"+nuoviParams, config);
      if (response) {
        setSchermata("fornitoreRimosso");
        fetch();
      }
      } else {
        alert("Non hai i permessi necessari per farlo")
      }
      
  }

    

  return (
    <div className={"h-" + height + "-ns sfondoColChiaro br4 pa3 tc sezioneConScroll"}>
            <h2 className="tc">{titolo}</h2>   
            {!schermata && utente.permessiAPI["update:database"] && <button
              className={stilePulsanti.buttonClassesWhiteNoBorder+" mb3"}
              onClick={()=>{
                fetchLista();
                setSchermata("nuovoForn");
              }}
            >Associa nuovo</button>}
            {/* <div className="w-40 flex flex-wrap h-100 bl-ns bordoColAlt">
                    <pre className="pa4">{JSON.stringify(idElemento1, null, 2)}</pre>
                </div> */}
            {!schermata && arr.length>0 &&
            arr.map((el) => riquadroElemento2(el,rimuoviAssociazione))}
            
            {schermata === "nuovoForn" && <div className='mt3'>
            <div className='flex justify-between mb2'><button
              className={stilePulsanti.buttonClassesWhiteNoBorder}
              onClick={()=>setSchermata(false)}
            >Indietro</button>
            <div className='gruppoInputRicercaOrizzontale'>
                <label className='mr1 b nonSelezionabile' for="filterText">Filtra per Nome</label>
                <input
                    value={filterText}
                    name="filterText"
                    onChange={handleChange}
                    id="filterText"
                    className="input-reset inputOrizzontale"
                    type="text"
                    aria-describedby="name-desc"
                    autoComplete="off" />
            </div> 
            </div>
            <div className='pa2 sfondoBiancoTema br3'>
              <ListaScegli 
                lista={filteredItemsNome}
                loading={loading}
                nomeDato={"nome"}
                labelDato={""}
                width={250}          
                associa={associa}
            /></div></div>}
            {schermata === "fornitoreRimosso" && <div>
              <div className='pa4 mb4'>Associazione rimossa correttamente.</div>
              <button
              className={stilePulsanti.buttonClassesWhiteNoBorder}
              onClick={()=>setSchermata(false)}
            >Indietro</button>

              </div>}
        </div>
  )
}

export default ListaAssocia;
